export enum DefaultPaymentMethodNamesEnum {
	bankSlipOrPix = "Boleto/PIX",
	money = "Dinheiro",
	creditCard = "Cartão de Crédito - até 12x"
}
